import { isDate as Nt } from "../../util/code-utils.js";
import {
  convertMsToSeconds as X,
  dateFromUnixTimestamp as V,
  secondsAgo as es,
  secondsInTheFuture as hs,
} from "../../util/date-utils.js";
export default class lr {
  constructor(t, s, e, i) {
    (this.yE = t),
      (this.HE = s),
      (this.comparator = e),
      (this.LE = i),
      (this.yE = t),
      (this.HE = s),
      (this.comparator = e),
      (this.LE = i),
      this.HE === lr.XE.QE &&
        this.comparator !== lr.BE.wE &&
        this.comparator !== lr.BE.jE &&
        this.comparator !== lr.BE.zE &&
        this.comparator !== lr.BE.FE &&
        (this.LE = V(this.LE));
  }
  xc(t) {
    let s = null;
    switch ((null != t && (s = t[this.yE]), this.comparator)) {
      case lr.BE.kE:
        return null != s && s.valueOf() === this.LE.valueOf();
      case lr.BE.xE:
        return null == s || s.valueOf() !== this.LE.valueOf();
      case lr.BE.JE:
        return null != s && typeof s == typeof this.LE && s > this.LE;
      case lr.BE.wE:
        return this.HE === lr.XE.QE
          ? null != s && Nt(s) && es(s) <= this.LE.valueOf()
          : null != s && typeof s == typeof this.LE && s >= this.LE;
      case lr.BE.VE:
        return null != s && typeof s == typeof this.LE && s < this.LE;
      case lr.BE.jE:
        return this.HE === lr.XE.QE
          ? null != s && Nt(s) && es(s) >= this.LE.valueOf()
          : null != s && typeof s == typeof this.LE && s <= this.LE;
      case lr.BE.qE:
        return (
          null != s &&
          "string" == typeof s &&
          typeof s == typeof this.LE &&
          null != s.match(this.LE)
        );
      case lr.BE.PE:
        return null != s;
      case lr.BE.WE:
        return null == s;
      case lr.BE.zE:
        return null != s && Nt(s) && hs(s) < this.LE;
      case lr.BE.FE:
        return null != s && Nt(s) && hs(s) > this.LE;
      case lr.BE.ZE:
        return (
          null == s ||
          typeof s != typeof this.LE ||
          "string" != typeof s ||
          null == s.match(this.LE)
        );
    }
    return !1;
  }
  static fromJson(t) {
    return new lr(
      t.property_key,
      t.property_type,
      t.comparator,
      t.property_value,
    );
  }
  bt() {
    let t = this.LE;
    return (
      Nt(this.LE) && (t = X(t.valueOf())),
      { k: this.yE, t: this.HE, c: this.comparator, v: t }
    );
  }
  static zn(t) {
    return new lr(t.k, t.t, t.c, t.v);
  }
}
(lr.XE = { $E: "boolean", tT: "number", sT: "string", QE: "date" }),
  (lr.BE = {
    kE: 1,
    xE: 2,
    JE: 3,
    wE: 4,
    VE: 5,
    jE: 6,
    qE: 10,
    PE: 11,
    WE: 12,
    zE: 15,
    FE: 16,
    ZE: 17,
  });
